import { parseISO } from 'date-fns';

/**
 * Compares two items by their modified date. Use this to sort a collection into newest first order.
 * @param item1 - First item to compare
 * @param item2 - Second item to compare
 */
export const compareModifiedDateNewestFirst = <T extends { modified: string }>(item1: T, item2: T) => {
  const dateA = parseISO(item1.modified);
  const dateB = parseISO(item2.modified);
  return dateB.getTime() - dateA.getTime();
};
